import { useContext } from 'react';
import { AppContext } from '../../context/appContext';

/**
 * returns identity data
 * @returns {object} derived from webShell data
 * relevant files src/client/utils/identity.js
 * using function initializeWebShellIdentity
 * data looks like
 * {
    altFirstName: undefined,
    altLastName: undefined,
    avatarUrl: undefined,
    email: "nathan.despain@nike.com",
    firstName: "Nathan",
    lastName: "DeSpain",
    mobileNumber: "+redacted",
    registeredCountry: "US",
    signInFlow: "CONTINUE",
    upmId: "3b5f59e0-e9a6-48de-8378-ce487ac414db",
    userType: "MEMBER",
 }
 */
const useIdentity = () => {
  const [data] = useContext(AppContext);
  return data?.identity || {};
};

export default useIdentity;
